import { 
  checkAndGetLocalStorageValue,
  generateJsonWebToken,
  checkAndGetSessionStorageValue,
  translateContent,
  getAndSetTranslateVal,
  checkAndChangeContent
 } from "../../../features/utils"
import { commonConstant, careOptions, switchResult } from "../../../server/triage/constants";

export function setTriageSelectedCareOption({ name, score, actions }) {

  actions.setTriageRequest({
    selectedCareOptionName: name,
      selectedCareOptionScore: score,

    // Clear any previous care option request
    selectedProvider: {},
    serviceRequest: {}
  })
    var isPatientDetailsAdded = checkAndGetLocalStorageValue("isPatientDetailsAdded");
    var IsValidUser = checkAndGetSessionStorageValue("IsValidUser")
    if (!IsValidUser &&name !== undefined && name !== "" && name !== careOptions.Telemedicine &&
        isPatientDetailsAdded == "false" && name !== careOptions.HouseVisit && name !== careOptions.ConciergeCare) {
        actions.updatePatientContact();
        localStorage.setItem("isPatientDetailsAdded", true);
    }
  // Clear previous session's results
  actions.clearTriageSessionResults()
}

export function getTriageSelectedCareOption({ state }) {

  const {
    selectedCareOptionName: name,
    selectedCareOptionScore: score,
  } = state.triageRequest

  return { name, score }
}

export function clearTriageSelectedCareOption({ state, setState, actions }) {

  const { recommendedCareOptions = [] } = state.triageResponse

  const {
    alt: name = '',
    value: score = 0
  } = recommendedCareOptions[0] || {}

  actions.setTriageSelectedCareOption({ name, score })
}
export async function setTriageDeclineCareOption({ actions, history, state }) {
  const { triageRequest } = state
  const { sessionId } = triageRequest
  const encounterToken = localStorage.getItem('token')
  var jwtAccess_Token = generateJsonWebToken()
  var access_Token = checkAndGetSessionStorageValue("accessToken")
  var translateArray = [
      {
          text: state.triageRequest.location.parts.administrative_area_level_1,
      },
      {
          text: state.triageRequest.location.parts.country,
      }
  ];
  var translatedContent = await translateContent(translateArray, "en");
  var listOfTranslatedArr = translatedContent.response.results;

  var tempAdminLevel = await getAndSetTranslateVal( listOfTranslatedArr, 0, state.triageRequest.location.parts.administrative_area_level_1 );
  var tempCountry = await getAndSetTranslateVal( listOfTranslatedArr, 1, state.triageRequest.location.parts.country );

  tempCountry = checkAndChangeContent(tempCountry, commonConstant.USA);
  var tempAddress = tempAdminLevel + "," + tempCountry;
 if(!state.isTravelAid2)
  {await actions.sendTriageRequest({
    action: "AddPatientDetails",
    data: {
      identifier: sessionId,
      token: encounterToken,
      name: state.IsValidUser?state.triageRequest.userName: localStorage.getItem("username"),
      Email: checkAndGetLocalStorageValue("userEmail"),
      DOB: state.triageRequest.dateofbirth,
      Address: tempAddress,
      IsPatient: true,
      jwtAccessToken : jwtAccess_Token,
      accessToken : access_Token,
      //coordinationType : switchResult(careOptions.DeclineCare)
    },
  });}
  
  const data = {
    identifier: sessionId,
    token: encounterToken,
    careDeclinedId: 14,//Care Declined
    selfServiceRequest: true,
    jwtAccessToken : jwtAccess_Token,
    accessToken : access_Token,
    Comment : "other"
}

await actions.sendTriageRequest({ action: 'submitDeclineCare', data })
}
